// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#previous-proposal-document-container {\r\n  background: #f7f6f6;\r\n  padding: 10px 0 15px 46px;\n}\n#previous-proposal-document-container .previous-proposal-item {\r\n  margin-bottom: 15px;\n}\r\n", ""]);
// Exports
module.exports = exports;
